module.exports = __webpack_public_path__ + "static/media/DIMENSIONS.7c7404cf.svg";